import React from "react";
import { Form, Col } from "react-bootstrap";
import { _t } from "../../../app/i18n/i18n";
import { getParam, addParam, push, removeParam } from "pages/search/api/filterUrlMaker";

export const Exclusions = () => {
  const handleClick = (text) => {
    //toggles exclusions
    if (getParam("exclusions") && getParam("exclusions").includes(text)) {
      push(removeParam("exclusions", text));
    } else {
      push(addParam("exclusions", text));
    }
  };
  return (
    <section>
      <Form.Group as={Form.Row} className="mb-1">
        <Form.Label column sm="2" className="pb-0">
          {_t("Excluded reports")}
        </Form.Label>
        <Col sm="5">
          <Form.Check
            type="checkbox"
            label={_t("Models")}
            name="exclusions"
            id="models"
            defaultChecked={getParam("exclusions") && getParam("exclusions").includes("Models")}
            onClick={() => handleClick("Models")}
          />
          <Form.Check
            type="checkbox"
            label={_t("Short notes (First Insights, Quick Notes)")}
            name="exclusions"
            id="short-notes"
            defaultChecked={getParam("exclusions") && getParam("exclusions").includes("Short Notes")}
            onClick={() => handleClick("Short Notes")}
          />
          <Form.Check
            type="checkbox"
            label={_t("Compilation (Morning packs)")}
            disabled
            name="exclusions"
            id="compilation"
            inline
          />
          <Form.Check
            type="checkbox"
            label={_t("Automated notes")}
            disabled
            name="exclusions"
            id="automated-notes"
            inline
          />
        </Col>
      </Form.Group>
    </section>
  );
};
